import React from 'react';
const tomes = [{
  number: '01',
  title: 'El Despertar Neuro-Sensorial',
  desc: 'De 0 a 6 meses. Actividades sensoriales y rutinas de estimulación para el primer semestre.'
}, {
  number: '02',
  title: 'El Conquistador de Espacios',
  desc: 'De 6 a 12 meses. Gateo, exploración y coordinación motriz.'
}, {
  number: '03',
  title: 'La Revolución del Lenguaje y los Primeros Pasos',
  desc: 'De 12 a 18 meses. Primeras palabras, comunicación y marcha independiente.'
}, {
  number: '04',
  title: 'Autonomía y Conexión Sináptica',
  desc: 'De 18 a 24 meses. Juego simbólico, regulación emocional e independencia.'
}, {
  number: '05',
  title: 'Pensamiento Lógico y Socialización',
  desc: 'De 24 a 30 meses. Resolución de problemas y primeras normas sociales.'
}, {
  number: '06',
  title: 'El Niño Pre-escolar: Potencial Académico',
  desc: 'De 30 a 36 meses. Atención, memoria y habilidades pre-académicas.'
}];
const includes = ['Actividades listas por área y por mes', 'Semáforo de alertas neurológicas', 'Checklists de hitos del desarrollo', 'Registro de progreso mensual', 'Protocolos de estimulación por área', 'Material explicativo para aplicar en casa'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(243,232,255) 0%, rgb(243,232,255) 85%, rgb(253,244,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-354">
      <div className="mx-auto max-w-4xl" data-id="element-355">

        {/* ── HEADING ── */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-356">
          Lo que{' '}
          <span style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-357">
            recibís
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-358">
          6 tomos · 360 páginas · Todo listo para aplicar hoy con tu hijo
        </p>

        {/* ── TOMOS ── */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-4" style={{
        border: '1px solid rgba(168,85,247,0.25)'
      }} data-id="element-359">
          {/* Header */}
          <div className="px-5 py-2.5" style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
        }} data-id="element-360">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-361">
              👶 LOS 6 TOMOS — Sistema Completo de Estimulación Temprana 0 a 36 Meses
            </h3>
          </div>

          {/* Rows */}
          <div className="divide-y divide-gray-100" data-id="element-362">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-363">
                <span className="shrink-0 text-lg font-black w-8 text-center" style={{
              color: 'rgba(168,85,247,0.35)'
            }} data-id="element-364">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-365">
                  <span className="block text-sm font-black text-gray-900" data-id="element-366">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-367">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold rounded-full px-2 py-0.5" style={{
              color: '#7c3aed',
              background: 'rgba(124,58,237,0.06)',
              border: '1px solid rgba(168,85,247,0.25)'
            }} data-id="element-368">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* ── CADA TOMO INCLUYE ── */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(168,85,247,0.25)'
      }} data-id="element-369">
          {/* Header */}
          <div className="px-5 py-2.5" style={{
          background: 'rgba(124,58,237,0.05)',
          borderBottom: '1px solid rgba(168,85,247,0.20)'
        }} data-id="element-370">
            <h3 className="text-sm font-black m-0" style={{
            color: '#7c3aed'
          }} data-id="element-371">
              Cada tomo incluye:
            </h3>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-372">
            {includes.map((item, i) => <div key={item} className={`flex items-start gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''}`} data-id="element-373">
                <span className="shrink-0 font-bold text-sm mt-0.5" style={{
              color: '#a855f7'
            }} data-id="element-374">
                  ✅
                </span>
                <span className="text-xs text-gray-700 leading-5" data-id="element-375">{item}</span>
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}